import { render, staticRenderFns } from "./Friends.vue?vue&type=template&id=4b160735&"
import script from "./Friends.vue?vue&type=script&lang=js&"
export * from "./Friends.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports